import { useAxiosGet } from './useGet';
import { useCallback, useEffect, useState } from 'react';
import { ShowUserResponse, User } from '@project_bamboo/shared';
import useUpdatePoint from './useUpdatePoint';
import useSendCorrectMessage from './useSendInformMail';
import useSendReturnMessage from './useSendReturnMail';

const useGetUsers = () => {
  const { getData, response, status } = useAxiosGet<ShowUserResponse>('/users/show');
  const updatePoint = useUpdatePoint();
  const sendMessage = useSendCorrectMessage();
  const sendReturnMessage = useSendReturnMessage();
  const [error, setError] = useState<string>('');
  const [success, setSuccess] = useState<string>('');
  const [rows, setRow] = useState<User[]>([]);

  useEffect(() => {
    if (status === 'idle') {
      getData();
    }
  }, [getData, status]); // getDataを依存配列から削除

  useEffect(() => {
    if (response) {
      setRow(response.data);
    }
  }, [response]);

  useEffect(() => {
    if (updatePoint.error) {
      setError(updatePoint.error);
      return;
    }
    if (updatePoint.response?.data) {
      const user = updatePoint.response.data;
      setRow((prevRows) => prevRows.map((u) => (u.id === user.id ? user : u)));
    }
  }, [updatePoint.response?.data, updatePoint.error]);

  useEffect(() => {
    if (sendMessage.error) {
      setError(sendMessage.error);
      return;
    }
    if (sendMessage.response?.data) {
      const user = sendMessage.response.data;
      setRow((prevRows) => prevRows.map((u) => (u.id === user.id ? user : u)));
      setSuccess('添削案内メールを送りました');
    }
  }, [sendMessage.response?.data, sendMessage.error]);

  useEffect(() => {
    if (sendReturnMessage.error) {
      setError(sendReturnMessage.error);
      return;
    }
    if (sendReturnMessage.response?.data) {
      const user = sendReturnMessage.response.data;
      setRow((prevRows) => prevRows.map((u) => (u.id === user.id ? user : u)));
      setSuccess('添削返却メールを送りました');
    }
  }, [sendReturnMessage.response?.data, sendReturnMessage.error]);

  const resetMessage = useCallback(() => {
    setSuccess('');
    setError('');
  }, []);

  return {
    status,
    rows,
    error,
    success,
    resetMessage,
    updatePoint,
    sendMessage,
    sendReturnMessage,
  };
};

export default useGetUsers;
